module.exports = __webpack_public_path__ + "static/media/cloud.454a7f6c.svg";